import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center text-center"},[_c(VDivider),_vm._t("default",[_c('span',{staticClass:"mx-4",attrs:{"id":"text-divider-span"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],{"id":"text-divider-slot"}),_c(VDivider)],2)}
var staticRenderFns = []

export { render, staticRenderFns }